import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestPending: boolean;
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  deleteConversation(
    request: Boundaries["deleteConversation"]["request"],
  ): void;
}

function useDeleteConversation(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isDeleteConversationRequestPending),
    isRequestSuccess: useSelector(selector.isDeleteConversationRequestSuccess),
    isRequestFailure: useSelector(selector.isDeleteConversationRequestFailure),
    deleteConversation: core.deleteConversation,
  };
}

export { useDeleteConversation };
